module.exports = __webpack_public_path__ + "static/media/after4.31e46cb3.jpg";